import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	resizer: {
		id: 'flex-resizer.handle.resizer',
		defaultMessage: 'Resize issue view side panel',
		description: 'Button label for resizing the issue view side panel',
	},
});
